import { functions } from '@/firebase'
import { traceHttpsCallable } from '@/utils/sentry'
import type {
  AdminSendCustomCustomerSmsRequest,
  AdminSendCustomCustomerSmsResponse,
  AdminToggleAllCustomersSmsNotificationsRequest,
  AdminToggleAllCustomersSmsNotificationsResponse,
  AdminToggleCustomerSmsNotificationsRequest,
  AdminToggleCustomerSmsNotificationsResponse,
  DailyClassSummarySmsManualResult,
  SendNotificationForPublishedRecordingRequest,
  TriggerCustomerClassReminderRequest,
  TriggerDailyClassRemindersRequest,
} from 'functions-node-notifications/src/types'

type ClassMutationResponse = { success: boolean; message?: string }
type ManualNotificationResponse = ClassMutationResponse & { sentCount?: number }

type EmailReminderResponse = {
  success: boolean
  message?: string
  sentCount?: number
  totalTokens?: number
}

export const Notifications = {
  adminSendCustomCustomerSms: traceHttpsCallable<
    AdminSendCustomCustomerSmsRequest,
    AdminSendCustomCustomerSmsResponse
  >(functions, 'notifications_adminSendCustomCustomerSms'),
  adminToggleCustomerSmsNotifications: traceHttpsCallable<
    AdminToggleCustomerSmsNotificationsRequest,
    AdminToggleCustomerSmsNotificationsResponse
  >(functions, 'notifications_adminToggleCustomerSmsNotifications'),
  adminToggleAllCustomersSmsNotifications: traceHttpsCallable<
    AdminToggleAllCustomersSmsNotificationsRequest,
    AdminToggleAllCustomersSmsNotificationsResponse
  >(functions, 'notifications_adminToggleAllCustomersSmsNotifications'),
  sendNotificationForPublishedRecording: traceHttpsCallable<
    SendNotificationForPublishedRecordingRequest,
    ClassMutationResponse
  >(functions, 'notifications_sendNotificationForPublishedRecording'),
  sendUpcomingClassNotificationsManual: traceHttpsCallable<object, ManualNotificationResponse>(
    functions,
    'notifications_sendUpcomingClassNotificationsManual',
  ),
  triggerDailyClassSummarySmsManual: traceHttpsCallable<object, DailyClassSummarySmsManualResult>(
    functions,
    'notifications_triggerDailyClassSummarySmsManual',
  ),
  triggerWeeklyClassReminders: traceHttpsCallable<
    TriggerDailyClassRemindersRequest,
    EmailReminderResponse
  >(functions, 'notifications_triggerWeeklyClassReminders'),
  triggerWeeklyClassReminderForCustomer: traceHttpsCallable<
    TriggerCustomerClassReminderRequest,
    EmailReminderResponse
  >(functions, 'notifications_triggerWeeklyClassReminderForCustomer'),
}
